import { Button, Grid, MenuItem, Select, Typography } from '@material-ui/core';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { ProofOfOccupationType } from 'realhaus-sdk';

export const ProofOfOccupationSelectForm: React.FC<{
    onDocumentSelected: (file: File, title: ProofOfOccupationType) => void;
    maxFileSizeInMB?: number;
}> = observer(({ onDocumentSelected, maxFileSizeInMB = 3 }) => {
    const [proofOfOccupationTitle, setProofOfOccupationTitle] =
        React.useState<ProofOfOccupationType>(ProofOfOccupationType.PAYSTUB);
    const [selectedFile, setSelectedFile] = React.useState<File | undefined>(undefined);
    const [error, setError] = React.useState<string | null>(null);

    return (
        <>
            <Grid container spacing={2}>
                {error && (
                    <Grid item xs={12}>
                        <Typography color='error' variant='body1'>
                            {error}
                        </Typography>
                    </Grid>
                )}

                <Grid item xs={12}>
                    <Typography display='inline' variant='body1' style={{ marginRight: 5 }}>
                        Document Type :
                    </Typography>
                    <Select
                        fullWidth
                        variant='standard'
                        value={proofOfOccupationTitle}
                        onChange={(e) =>
                            setProofOfOccupationTitle(e.target.value as ProofOfOccupationType)
                        }
                    >
                        <MenuItem value={ProofOfOccupationType.PAYSTUB}>Paystub</MenuItem>
                        <MenuItem value={ProofOfOccupationType.EMPLOYMENT_LETTER}>
                            Employment Letter
                        </MenuItem>
                    </Select>
                </Grid>

                <Grid item xs={12}>
                    <Button
                        variant='outlined'
                        color='primary'
                        size='small'
                        onClick={() => {
                            const el = document.getElementById(
                                'proof-of-occupation-file',
                            ) as HTMLInputElement | null;
                            el?.click();
                        }}
                        fullWidth
                    >
                        Select File
                    </Button>
                    {selectedFile && (
                        <>
                            <Typography
                                color='textSecondary'
                                style={{ marginTop: 2 }}
                                variant='body1'
                            >
                                {selectedFile.name}
                            </Typography>
                        </>
                    )}

                    <input
                        accept='*'
                        id='proof-of-occupation-file'
                        type='file'
                        hidden={true}
                        onChange={(e) => {
                            setError(null);

                            const file = e.currentTarget.files?.[0];
                            if (!file) return;
                            const fileSize = Math.round(file.size / 1024);
                            const maxFileSize = maxFileSizeInMB * 1024;
                            if (fileSize >= maxFileSize) {
                                setError(`File size must not be more than ${maxFileSizeInMB} MB`);
                                return;
                            }

                            setSelectedFile(file);
                            onDocumentSelected(file, proofOfOccupationTitle);
                        }}
                    />
                </Grid>
            </Grid>
        </>
    );
});
